import { render, staticRenderFns } from "./OptimizerInputObserver.vue?vue&type=template&id=38cac828&"
import script from "./OptimizerInputObserver.vue?vue&type=script&lang=js&"
export * from "./OptimizerInputObserver.vue?vue&type=script&lang=js&"
import style0 from "./OptimizerInputObserver.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports